import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import Logger from 'core/utils/Logger'
import { ICheckStatusResponse } from 'partner360/models/report/ICheckStatusResponse'
import settings from 'src/config/settings'

export const checkReportStatus = async () => {
  const serviceUrl = settings.httpsServices.partner360
    ? settings.httpsServices.partner360
    : 'https://partner360-service-itg.corp.hpicloud.net'

  const { app } = appGetState()
  const [token] = getTokens(app.ownerId)
  const url = `${serviceUrl}/api/v0/exportDocument/status`
  const response = await fetch(url, {
    headers: {
      Authorization: `${token}`,
    },
    method: 'POST',
  })

  if (response.ok) {
    const resJson = await response.json()
    const data: ICheckStatusResponse[] = resJson.data

    return data
  } else {
    Logger.error('CheckReportStatus Error:', response.status, response.statusText)
  }

  return []
}
